module.exports = __webpack_public_path__ + "img/carTotal.247955df.png";